import { safeAccessibilityRole } from '@/constants/utils/a11y';
import React, { useState } from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { MONO } from '@/components/Landing/landingTokens';
import { ENDPOINT_GROUPS } from '@/constants/apiContent';
import { ApiBody, ApiEyebrow, ApiLink, ApiSection, ApiTabs, ApiTitle, useApiDesign } from './ApiEditorial';

const GROUPS = ENDPOINT_GROUPS.map((group, index) => ({
  ...group, id: String(index), label: group.group, shortLabel: ['Chat & agents', 'Media', 'Account'][index],
}));

function ApiEndpoints() {
  const { c, compact, mobile } = useApiDesign();
  const [activeId, setActiveId] = useState(GROUPS[0].id);
  const active = GROUPS.find(group => group.id === activeId);
  return (
    <ApiSection label="API endpoints" background={c.soft}>
      <ApiEyebrow>The API reference</ApiEyebrow>
      <View style={{ flexDirection: compact ? 'column' : 'row', justifyContent: 'space-between', gap: 24, marginBottom: 32 }}>
        <ApiTitle>One key. All the essentials.</ApiTitle>
        <ApiBody style={{ maxWidth: 390 }}>Chat, generate media, work with files, and manage your account.</ApiBody>
      </View>
      <View style={{ padding: mobile ? 8 : 10, borderRadius: 22, borderWidth: 1, borderColor: c.rule, backgroundColor: c.soft }}>
        <ApiTabs id="api-endpoints" label="Endpoint category" items={GROUPS} activeId={activeId} onChange={setActiveId} />
        <View nativeID={`api-endpoints-panel-${active.id}`} accessibilityRole={safeAccessibilityRole('tabpanel')} aria-labelledby={`api-endpoints-tab-${active.id}`} tabIndex={0}
          style={{ backgroundColor: c.surface, borderRadius: 15, marginTop: 10, paddingHorizontal: mobile ? 16 : 28, paddingVertical: 8 }}>
          {active.endpoints.map((endpoint, index) => (
            <View key={endpoint.method + endpoint.path} style={{ flexDirection: compact ? 'column' : 'row', gap: compact ? 4 : 24, paddingVertical: 17, borderTopWidth: index ? 1 : 0, borderTopColor: c.rule }}>
              <View style={{ flex: compact ? undefined : 1.05, flexDirection: 'row', alignItems: 'baseline', gap: 14, minWidth: 0 }}>
                <Text weight="medium" style={{ color: c.secondary, fontFamily: MONO, fontSize: 10, lineHeight: 21, width: 42 }}>{endpoint.method}</Text>
                <Text style={{ color: c.ink, fontFamily: MONO, fontSize: mobile ? 11 : 13, lineHeight: 21, flex: 1, overflowWrap: 'anywhere' }}>{endpoint.path}</Text>
              </View>
              <Text style={{ flex: compact ? undefined : 1, color: c.secondary, fontSize: 13, lineHeight: 22, paddingLeft: compact ? 56 : 0 }}>{endpoint.label}</Text>
            </View>
          ))}
        </View>
      </View>
      <ApiLink href="/docs/api-endpoints" style={{ marginTop: 20 }}>Explore the full reference</ApiLink>
    </ApiSection>
  );
}
export default React.memo(ApiEndpoints);
